import { createWebHistory, createRouter } from "vue-router";
import Login from "@/views/Onboarding/login.vue";
import ForgotPassword from "@/views/Onboarding/forgot-password.vue";
import OTP from "@/views/Onboarding/otp.vue";
import ResetPassword from "@/views/Onboarding/reset-password.vue";
import MyProfile from "@/views/Onboarding/my-profile.vue";
import Admin from "@/views/Admin/admin.vue";
import AddAdmin from "@/views/Admin/add-admin.vue";
import DropdownMenu from "@/views/DropdownMenu/dropdown-menu.vue";
import BodyStructure from "@/views/DropdownMenu/body-structure.vue";
import Personality from "@/views/DropdownMenu/personality.vue";
import MaritalStatus from "@/views/DropdownMenu/marital-status.vue";
import ES from "@/views/DropdownMenu/es.vue";
import Devak from "@/views/DropdownMenu/devak.vue";
import Diet from "@/views/DropdownMenu/diet.vue";
import SkinTone from "@/views/DropdownMenu/skin-tone.vue";
import Occupation from "@/views/DropdownMenu/occupation.vue";
import Relations from "@/views/DropdownMenu/relations.vue";
import EditSetting from "@/views/Setting/edit-setting.vue";
import Setting from "@/views/Setting/setting.vue";
import ContactUs from "@/views/Setting/contact.vue";
import AddContact from "@/views/Setting/add-contact.vue";
import Report from "@/views/Report/report.vue";
import SubscriptionPlan from "@/views/SubscriptionPlan/subscription-plan.vue";
import AddSubscriptionPlan from "@/views/SubscriptionPlan/add-subscription-plan.vue";
import SuccessStories from "@/views/SuccessStories/success-stories.vue";
import AddSuccessStories from "@/views/SuccessStories/add-success-stories.vue";
import DeleteProfile from "@/views/DeleteProfileRequest/delete-profile.vue";
import Geographical from "@/views/Geographical/geographical.vue";
import District from "@/views/Geographical/district.vue";
import City from "@/views/Geographical/city.vue";
import WorkLocation from "@/views/Geographical/work-location.vue";
import Banner from "@/views/Banner/banner.vue";
// import Users from "@/views/ManageUser/user.vue";
import MemberList from "@/views/ManageUser/member-list.vue";
import MarriedList from "@/views/ManageUser/married-list.vue";
import ShortList from "@/views/ManageUser/short-list.vue";
import BroadList from "@/views/ManageUser/broad-list.vue";
import AddUser from "@/views/ManageUser/add-user.vue";
import ViewUser from "@/views/ManageUser/view-user.vue";
import SubscriptionPlanHistory from "@/views/ManageUser/subscription-plan-history.vue";
import UserActivity from "@/views/ManageUser/user-activity.vue";
import Role from "@/views/Role/role.vue";
import AddRole from "@/views/Role/add-role.vue";
import Menu from "@/components/menu.vue";
import MainView from "@/views/main.vue";
import AccessDenied from "@/views/Error/access-denied.vue"
import AddNotification from "@/views/SendNotification/notification.vue"
import SendNotification from "@/views/SendNotification/send-notification.vue"

const routes = [{
    path: "",
    redirect: Login,
},
{
    path: "/login",
    name: "Login",
    component: Login,
},
{
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
},
{
    path: "/otp",
    name: "OTP",
    component: OTP,
},
{
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
},
{
    path: '',
    name: "Main",
    component: MainView,
    meta: {
        requiresAuth: true
    },
    children: [
        {
            path: "/access-denied",
            name: "AccessDenied",
            component: AccessDenied,
        },
        // =============== Admin ===============
        {
            path: "/admin",
            name: "Admin",
            component: Admin
        },
        {
            path: "/add-admin",
            name: "Add Admin",
            component: AddAdmin
        },
        {
            path: "/edit-admin/:uuid",
            name: "Edit Admin",
            component: AddAdmin
        },
        //==========Dropdown===========
        {
            path: "/dropdown-menu",
            name: "Dropdown Menu",
            component: DropdownMenu
        },
        {
            path: "/body-structure",
            name: "Body Structure",
            component: BodyStructure
        },
        {
            path: "/marital-status",
            name: "Marital Status",
            component: MaritalStatus
        },
        {
            path: "/devak",
            name: "Devak",
            component: Devak
        },
        {
            path: "/es",
            name: "ES",
            component: ES
        },
        {
            path: "/personality",
            name: "Personality",
            component: Personality
        },
        {
            path: "/diet",
            name: "Diet",
            component: Diet
        },
        {
            path: "/skin-tone",
            name: "Skin Tone",
            component: SkinTone
        },
        {
            path: "/occupation",
            name: "Occupation",
            component: Occupation
        },
        {
            path: "/relation",
            name: "Relations",
            component: Relations
        },
        //===========My profile========
        {
            path: "/my-profile",
            name: "MyProfile",
            component: MyProfile,
        },


        // =============== Setting ===============
        {
            path: "/setting",
            name: "Setting",
            component: Setting
        },
        {
            path: "/edit-setting",
            name: "Edit Setting",
            component: EditSetting
        },
        {
            path: "/contact",
            name: "Contact Us",
            component: ContactUs
        },
        {
            path: "/add-contact",
            name: "Add Contact",
            component: AddContact
        },
        {
            path: "/edit-contact/:uuid",
            name: "Edit Contact",
            component: AddContact
        },
        //================Report===============
        {
            path: "/report",
            name: "Report",
            component: Report
        },
        // =============== Subscription Plan ===============
        {
            path: "/subscription-plan",
            name: "SubscriptionPlan",
            component: SubscriptionPlan
        },
        {
            path: "/add-subscription-plan",
            name: "Add Subscription Plan",
            component: AddSubscriptionPlan
        },
        {
            path: "/edit-subscription-plan/:uuid",
            name: "Edit Subscription Plan",
            component: AddSubscriptionPlan
        },
        //=================Success Stories============
        {
            path: "/success-stories",
            name: "Success Stories",
            component: SuccessStories
        },
        {
            path: "/add-succcess-stories",
            name: "Add Success Stories",
            component: AddSuccessStories
        },
        {
            path: "/view-succcess-stories/:uuid",
            name: "View Success Stories",
            component: AddSuccessStories
        },
        //===============Geographical================
        {
            path: "/geographical",
            name: "Geographical",
            component: Geographical
        },
        {
            path: "/district",
            name: "District",
            component: District
        },
        {
            path: "/city",
            name: "City",
            component: City
        },
        {
            path: "/work-location",
            name: "Work Location",
            component: WorkLocation
        },
        // =============== Banner ===============
        {
            path: "/banner",
            name: "Banner",
            component: Banner
        },
        //================ User ==============
        // {
        //     path: "/user",
        //     name: "Users",
        //     component: Users
        // },
        {
            path: "/member-list",
            name: "Member List",
            component: MemberList
        },
        {
            path: "/member-list/:type",
            name: "Member List NEW ",
            component: MemberList
        },
        {
            path: "/married-list",
            name: "Married List",
            component: MarriedList
        },
        {
            path: "/married-list/:type",
            name: "Married List NEW ",
            component: MarriedList
        },
        {
            path: "/short-list/:uuid/:type",
            name: "ShortList",
            component: ShortList
        },
        {
            path: "/broad-list/:uuid/:type",
            name: "BroadList",
            component: BroadList
        },
        {
            path: "/user-activity/:uuid",
            name: "UserActivity",
            component: UserActivity
        },
        {
            path: "/add-user",
            name: "Add User",
            component: AddUser
        },

        {
            path: "/edit-user/:uuid",
            name: "Edit User",
            component: AddUser
        },
        {
            path: "/view-user/:uuid",
            name: "View User",
            component: ViewUser
        },
        {
            path: "/view-user-detail/:uuid/:type",
            name: "View User",
            component: ViewUser
        },
        {
            path: "/subscription-plan-history/:uuid",
            name: "Subscription Plan History",
            component: SubscriptionPlanHistory
        },
        // =============== Role ===============
        {
            path: "/role",
            name: "Role",
            component: Role
        },
        {
            path: "/add-role",
            name: "Add Role",
            component: AddRole
        },
        {
            path: "/edit-role/:uuid",
            name: "Edit Role",
            component: AddRole
        },
        // =============== Delete Profile ===============
        {
            path: "/delete-profile",
            name: "Delete Profile",
            component: DeleteProfile
        },
        {
            path: "/menu",
            name: "Menu",
            component: Menu
        },
        // =============== Notification ===============
        {
            path: "/notification",
            name: "Notification",
            component: AddNotification
        },
        {
            path: "/send-notification",
            name: "Send Notification",
            component: SendNotification
        },
    ]
}
];
const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('token') == null) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        if (to.path === '/login') {
            if (localStorage.getItem('token') != null) {
                next({
                    path: '/admin',
                    params: { nextUrl: to.fullPath }
                })
            } else {
                next()
            }
        } else {
            next()
        }
    }
});

export default router;